"use client";
import { ValidLocale } from "i18n";
import { useMemo } from "react";
import { usePathname } from "next/navigation";
import { findStyleName } from "../shared/generators/generators";
import useUgc from "@/app/context/UgcContext";

interface Props {
  sortBy?: string;
  pathCode: ValidLocale;
  queryParam: any;
  style: any;
  translations: any;
  selectedGroups: any;
  isListView: boolean;
}

export const CategoryTextUgc = ({
  sortBy = "hot",
  pathCode,
  queryParam,
  style,
  translations,
  selectedGroups,
  isListView,
}: Props) => {
  const { selectedStyleUgc } = useUgc();
  const pathname = usePathname();
  const pathChunk = pathname.split("/");
  const localeKey = translations.key;
  const _id = localeKey === "en-US" ? pathChunk[2] : pathChunk[4];

  const { groupNames, groupString, allString } = useMemo(() => {
    if (selectedGroups[0] === "all") {
      return {
        groupNames: translations.categoriesFor,
        groupString: "",
        allString: translations.allH1,
      };
    }

    const selectedGroupIds = Object.values(selectedGroups) as string[];
    const selectedGroupNames = selectedStyleUgc.tagGroups
      .filter((tagGroup) => selectedGroupIds.includes(tagGroup._id))
      .map((tagGroup) =>
        tagGroup._id === "all"
          ? tagGroup.names[Number(translations.index)].value
          : tagGroup.names[translations.key],
      );

    return {
      groupNames: selectedGroupNames.length ? `${selectedGroupNames.join(", ")}` : undefined,
      groupString: translations.groupFor,
    };
  }, [selectedGroups, selectedStyleUgc, translations]);

  const buildText = useMemo(() => {
    if (groupNames === undefined) return "Loading...";

    const baseText = [
      allString,
      !isListView ? translations[`${sortBy}H1`] : "",
      groupNames,
      groupString,
      findStyleName(translations.key, style),
      translations.styleH1Singular,
    ]
      .filter(Boolean)
      .join(" ");

    return baseText;
  }, [sortBy, translations, groupNames, groupString, style, isListView]);

  return <h1 className="mb-4 text-lg font-bold text-white sm:text-xl">{buildText}</h1>;
};
